import React, { useEffect, useState, useRef } from 'react';
import { ChevronUpIcon } from 'lucide-react';
interface SEOLink {
  label: string;
  href: string;
}
interface SEORow {
  items: SEOLink[];
}
interface SEOAccordionProps {
  title: string;
  rows: SEORow[];
  defaultOpen?: boolean;
}
export function SEOAccordion({
  title,
  rows,
  defaultOpen = false
}: SEOAccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const contentRef = useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = useState<number>(0);
  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [isOpen, rows]);
  return <div className="border border-gray-300 rounded overflow-hidden" data-id="element-130">
      {/* Header Bar */}
      <a href="#" onClick={e => {
      e.preventDefault();
      setIsOpen(!isOpen);
    }} role="button" aria-expanded={isOpen} className="w-full flex items-center justify-between px-5 py-3 bg-[#6B7280] hover:bg-[#5f6673] transition-colors duration-150 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-inset" data-id="element-131">
        <span className="text-white font-medium text-base" data-id="element-132">{title}</span>
        <div className="transition-transform duration-200 ease-in-out" style={{
        transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)'
      }} data-id="element-133">
          <ChevronUpIcon className="w-5 h-5 text-white" data-id="element-134" />
        </div>
      </a>

      {/* Content */}
      <div ref={contentRef} className="transition-[height,opacity] duration-250 ease-in-out overflow-hidden" style={{
      height: isOpen ? contentHeight : 0,
      opacity: isOpen ? 1 : 0
    }} data-id="element-135">
        <div className="bg-[#F9F9F9] px-5 py-5" data-id="element-136">
          <div className="space-y-1" data-id="element-137">
            {rows.map((row, rowIndex) => <div key={rowIndex} className="grid gap-x-4" style={{
            gridTemplateColumns: 'repeat(5, minmax(0, 1fr))'
          }} data-id="element-138">
                {row.items.map(item => <a key={item.href} href={item.href} className="text-gray-700 hover:text-primary hover:underline focus:outline-none focus-visible:underline focus-visible:text-primary text-sm py-0.5 transition-colors duration-100" data-id="element-139">
                    {item.label}
                  </a>)}
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}